const faqs = [
  {
    q: '如何获取探花最新地址？',
    a: '本站（探花官网入口发布页）会第一时间更新探花最新地址与探花新地址。建议您收藏本页面或关注探花在线更新通知，确保不会错过任何探花入口变更信息。',
  },
  {
    q: '探花系列网站是否安全？',
    a: '我们采用多重安全防护措施保障探花官网访问的安全性。所有探花入口均经过严格审核，建议通过本站提供的探花最新地址访问以获取最安全的使用体验。',
  },
  {
    q: '探花在线资源多久更新一次？',
    a: '探花精选资源保持每日更新频率，确保用户随时可以获取最新、最全的探花在线内容。精品探花合集会根据内容热度与用户反馈进行定期调整优化。',
  },
  {
    q: '探花入口打不开怎么办？',
    a: '如果当前探花地址无法访问，请刷新本页面获取最新的探花新地址。我们持续监控探花官网入口可用性，并在第一时间更新替代入口，防止您走失。',
  },
  {
    q: '如何投稿或推荐探花资源？',
    a: '欢迎通过本站「联系我们」模块提交探花资源推荐或内容投稿。我们的编辑团队会认真评估每一份来稿，优质内容将入选探花精选合集并标注来源。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="scroll-mt-16 py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
            常见问答
          </h2>
          <div className="max-w-3xl mx-auto space-y-3">
            {faqs.map((faq, idx) => (
              <div key={idx} className="bg-background-50 rounded-lg border border-background-200/60 p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 flex items-start gap-3">
                  <span className="text-accent-500 flex-shrink-0 mt-0.5">
                    <i className="ri-question-line"></i>
                  </span>
                  {faq.q}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed pl-7">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}